import { PostRequest, RequestPromise } from "../hook/useRequest";

/**
 * Demande l'envoi d'un mail de réinitialisation de mot de passe.
 * Réponse toujours 200 (anti-énumération côté back).
 */
const ForgotPassword = (email: string): RequestPromise => {
    return PostRequest("/authentication/forgot_password", { email });
};

/**
 * Réinitialise le mot de passe à partir d'un token reçu par email.
 */
const ResetPassword = (token: string, password: string): RequestPromise => {
    return PostRequest("/authentication/reset_password", { token, password });
};

export { ForgotPassword, ResetPassword };
